import { defineRequest } from "@/lib/fetch-tools";
import { FissionResponse } from "./types";
import { getRequestDefinitionType } from "@/lib/fetch-utils";

// http://localhost:1025/api/pc/trade/getTime?companyId=1
export const getTradeTime = defineRequest<
  FissionResponse<{
    currentTime: number;
    tradeTimeList: Array<{
      time: string;
      subTime: string[];
    }>;
  }>,
  {
    companyId?: string
  }
>('/api/pc/trade/getTime');

export type GetTradeTimeType = getRequestDefinitionType<typeof getTradeTime>;


